import type { Me } from '@bk/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api, errorMessage } from '../lib/api';
import { APP_NAME } from '../lib/app-name';
import { navigate } from '../lib/router';
import { AppMark, Button, Card, ErrorText } from '../ui';

/** L'invito si accetta dopo l'accesso, anche quando l'account non appartiene ancora all'azienda. */
export function JoinPersonPage({ tenantId, token, me, onLogout }: { tenantId: string; token: string; me: Me; onLogout: () => void }) {
  const qc = useQueryClient();
  const accept = useMutation({
    mutationFn: () => api<{ tenant_id: string; person_id: string }>(`/tenants/${encodeURIComponent(tenantId)}/person-invitations/accept`, { body: { token } }),
    onSuccess: async (result) => {
      await qc.invalidateQueries({ queryKey: ['tenants'] });
      navigate(`/t/${result.tenant_id}/oggi`);
    },
  });
  return (
    <main className="mx-auto flex min-h-screen max-w-lg flex-col justify-center gap-6 px-4 py-10">
      <div className="flex items-center gap-3 text-accent">
        <AppMark className="h-10 w-10" />
        <span className="text-xl font-semibold">{APP_NAME}</span>
      </div>
      <Card>
        <h1 className="text-lg font-semibold">Entra nell’azienda</h1>
        <p className="mt-2 text-sm text-ink/70">Accettando l’invito colleghi il tuo account alla persona configurata dall’azienda e accedi ai tuoi compiti.</p>
        <p className="mt-4 text-sm">Hai effettuato l’accesso come <strong>{me.email}</strong>.</p>
        <p className="mt-1 text-xs text-ink/60">Usa lo stesso indirizzo email a cui è destinato l’invito. Se hai un altro account aperto, esci e accedi con quello corretto.</p>
        <div className="mt-4">
          <ErrorText>{accept.error ? errorMessage(accept.error) : ''}</ErrorText>
        </div>
        <div className="mt-4 flex flex-wrap gap-2">
          <Button disabled={accept.isPending || accept.isSuccess} onClick={() => accept.mutate()}>
            {accept.isPending ? 'Collego l’account…' : 'Accetta invito'}
          </Button>
          <Button variant="ghost" disabled={accept.isPending} onClick={onLogout}>Esci e usa un altro account</Button>
        </div>
      </Card>
    </main>
  );
}
